module.exports = __webpack_public_path__ + "img/monterey-rectangle-top-angle.858b619e.png";